// DoctorTimingForm.tsx
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  PagerTargetEvent,
  HeaderThElement,
} from "@progress/kendo-react-data-tools";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import IconButton from "../../components/common/IconButton";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import ShadowCard from "../../components/common/ShadowCard";
import AlertBox from "../../components/common/AlertBox";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import { MdDelete, MdEdit } from "react-icons/md";
import {
  deleteDoctorTiming,
  getDoctorTimingsByDoctorID,
  insertDoctorTiming,
  updateDoctorTiming,
} from "./services/doctor.service";
import { clearDoctorTimings } from "./doctorSlice";
// import FormTimePicker from "../../components/formFields/FormTimeField";
import moment from "moment";
// import FormMultiSelectionFiled from "../../components/formFields/FormMultiSelectionFiled";
import { getAllActiveHospitals } from "../hospital/services/hospital.service";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import FormNumericTextField from "../../components/formFields/FormNumericTextField";
// import { DAYS_OF_WEEK } from "../../_contstants/common";
import DoctorTimingArray from "./DoctorTimingArray";
import ExpandableText from "../../components/common/ExpandableText";

interface PageState {
  skip: number;
  take: number;
}
const initialDataState: PageState = { skip: 0, take: 10 };

const DoctorTimingForm: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const DoctorID = location.state?.DoctorID;

  const [editItem, setEditItem] = useState<any>(null);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [formKey, setFormKey] = useState(1);
  const [page, setPage] = useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >();

  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const timings = useAppSelector((state) => state.doctor.DoctorTimings);
  const loading = useAppSelector((state) => state.doctor.loading);
  const formLoading = useAppSelector((state) => state.doctor.formLoading);
  const HospitalList = useAppSelector((state) => state.hospital.HospitalList);

  useEffect(() => {
    setFormKey((p) => p + 1);
  }, [timings, editItem]);
  useEffect(() => {
    if (DoctorID) dispatch(getDoctorTimingsByDoctorID(DoctorID));
    dispatch(getAllActiveHospitals());
    return () => {
      dispatch(clearDoctorTimings());
    };
  }, [DoctorID]);

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take = targetEvent.value === "All" ? timings.length : event.page.take;
    if (targetEvent.value) setPageSizeValue(targetEvent.value);
    setPage({ ...event.page, take });
  };

  const handleAdd = async (values: any) => {
    const payload = {
      DoctorID: DoctorID,
      HospitalID: values?.HospitalID ? +values?.HospitalID : null,
      Rate: values?.Rate ? +values?.Rate : null,
      Timings: values?.Timings?.map((item: any) => {
        return {
          Day: item.Day.length > 0 ? item.Day?.join(",") : "",
          StartTime: item.StartTime
            ? moment(item.StartTime).format("HH:mm:ss")
            : "",
          EndTime: item.EndTime ? moment(item.EndTime).format("HH:mm:ss") : "",
        };
      }),
    };
    const response = await dispatch(insertDoctorTiming(payload));
    if (response?.meta?.requestStatus === "fulfilled") {
      dispatch(getDoctorTimingsByDoctorID(DoctorID));
      setEditItem(null);
    }
  };

  const handleUpdate = async (values: any) => {
    const payload = {
      ID: editItem.ID,
      DoctorID: DoctorID,
      HospitalID: values?.HospitalID ? +values?.HospitalID : null,
      Rate: values?.Rate ? +values?.Rate : null,
      Timings: values?.Timings?.map((item: any) => {
        return {
          Day: item.Day.length > 0 ? item.Day?.join(",") : "",
          StartTime: item.StartTime
            ? moment(item.StartTime).format("HH:mm:ss")
            : "",
          EndTime: item.EndTime ? moment(item.EndTime).format("HH:mm:ss") : "",
        };
      }),
    };
    const response = await dispatch(updateDoctorTiming(payload));
    if (response?.meta?.requestStatus === "fulfilled") {
      dispatch(getDoctorTimingsByDoctorID(DoctorID));
      setEditItem(null);
    }
  };

  const handleDelete = async () => {
    if (deleteId) {
      const response = await dispatch(deleteDoctorTiming(deleteId));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(getDoctorTimingsByDoctorID(DoctorID));
        dispatch(closeDialog());
        setDeleteId(null);
      }
    }
  };

  const ActionCell = (props: any) => (
    <td
      className={props.className}
      style={{
        ...props.style,
        textAlign: "center",
        // display: "flex",
        // justifyContent: "space-evenly",
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "flex",
          justifyContent: "space-evenly",
        }}
      >
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Edit"
          onClick={() =>
            setEditItem({
              ...props.dataItem,
              Timings: props.dataItem.Timings?.map((item: any) => {
                return {
                  Day: item.Day.length > 0 ? item.Day?.split(",") : "",
                  StartTime: item.StartTime
                    ? moment(item.StartTime, "HH:mm:ss").toDate()
                    : "",
                  EndTime: item.EndTime
                    ? moment(item.EndTime, "HH:mm:ss").toDate()
                    : "",
                };
              }),
            })
          }
          icon={MdEdit}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "20px" }}
        />
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Delete"
          className="color-red"
          onClick={() => {
            dispatch(openDialog("deleteDoctorTiming"));
            setDeleteId(props.dataItem.ID);
          }}
          icon={MdDelete}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
      </div>
    </td>
  );

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 3 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <td {...(props as any).tdProps} colSpan={1} className={"table-cell"}>
      {props.children}
    </td>
  );

  return (
    <>
      {dialogName === "deleteDoctorTiming" && (
        <AppDialog>
          <>
            <Typography.h5>Delete Timing</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this timing entry?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{ display: "flex", justifyContent: "end", gap: "10px" }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={handleDelete}
                  type="button"
                  disabled={loading}
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}

      <GridLayout style={{ marginTop: 20 }} gap={{ rows: 10, cols: 10 }}>
        <GridLayoutItem colSpan={4}>
          <ShadowCard style={{ padding: 20 }}>
            <Typography.h4 style={{ margin: "0 0 20px 0", color: "#495057" }}>
              {editItem ? "Edit Timing" : "Add Timing"}
            </Typography.h4>
            <Form
              key={formKey}
              onSubmit={editItem ? handleUpdate : handleAdd}
              initialValues={
                editItem || {
                  HospitalID: "",
                  Rate: 0,
                  Timings: [{ Day: [], StartTime: null, EndTime: null }],
                }
              }
              render={(formRenderProps: FormRenderProps) => (
                <FormElement>
                  <GridLayout
                    style={{ marginRight: 40 }}
                    gap={{ rows: 15, cols: 20 }}
                    cols={[
                      { width: "33%" },
                      { width: "33%" },
                      { width: "34%" },
                    ]}
                  >
                    <GridLayoutItem>
                      <Field
                        name="HospitalID"
                        label="Hospital"
                        placeholder="Select Hospital"
                        component={FormSelectionField}
                        options={HospitalList?.map((item) => ({
                          value: item.ID,
                          label: item.HospitalName,
                        }))}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem></GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        wrapperClassName="right-aligned-field"
                        name="Rate"
                        label="Consultation Fee"
                        placeholder="0"
                        component={FormNumericTextField}
                      />
                    </GridLayoutItem>

                    <GridLayoutItem
                      colSpan={3}
                      style={{
                        background: "whitesmoke",
                        padding: 10,
                        borderRadius: 10,
                      }}
                    >
                      <FieldArray
                        formRenderProps={formRenderProps}
                        component={DoctorTimingArray}
                        name="Timings"
                      />
                    </GridLayoutItem>

                    {/* <GridLayoutItem>
                      <Field
                        name="Day"
                        label="Day"
                        placeholder="Select day"
                        component={FormMultiSelectionFiled}
                        options={DAYS_OF_WEEK}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="StartTime"
                        label="Start Time"
                        component={FormTimePicker}
                        validator={requiredValidator}
                        onChange={(e) =>
                          !editItem &&
                          e &&
                          e?.value &&
                          formRenderProps.onChange("EndTime", {
                            value: e.value,
                          })
                        }
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="EndTime"
                        label="End Time"
                        component={FormTimePicker}
                        minDate={moment(
                          formRenderProps.valueGetter("StartTime"),
                        ).toDate()}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem> */}
                    <GridLayoutItem
                      colSpan={3}
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: "10px",
                      }}
                    >
                      {editItem && (
                        <Button
                          type="button"
                          fillMode={"outline"}
                          themeColor={"secondary"}
                          onClick={() => setEditItem(null)}
                        >
                          Cancel Edit
                        </Button>
                      )}
                      <ButtonWithLoading
                        label={editItem ? "Update" : "Add Timing"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || formLoading}
                        loading={formLoading}
                      />
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />

            <Typography.h4 style={{ margin: "0 0 20px 0", color: "#495057" }}>
              Timings ({timings?.length || 0})
            </Typography.h4>
            {timings && timings.length > 0 ? (
              <KendoGrid
                style={{ maxHeight: "calc(100vh - 400px)" }}
                data={timings.slice(page.skip, page.take + page.skip)}
                skip={page.skip}
                take={page.take}
                total={timings.length}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [5, 10, "All"],
                  pageSizeValue,
                  type: "input",
                }}
                onPageChange={pageChange}
                cells={{ headerCell: HeaderCustomCell, data: MyDataCustomCell }}
              >
                <Column field="HospitalName" title="Hospital Name" />
                <Column field="Rate" title="Rate" />
                <Column
                  field="Timings"
                  title="Timings"
                  cells={{
                    data: (props) => (
                      <ExpandableText
                        text={
                          props.dataItem.Timings.length > 0
                            ? props.dataItem.Timings.map(
                                (item: any, index: number, arr: any[]) => (
                                  <div key={index}>
                                    <div className="fw-bold">
                                      {item.Day.length > 0
                                        ? item.Day.split(",").join(", ")
                                        : ""}
                                    </div>
                                    {item.StartTime
                                      ? moment(
                                          item.StartTime,
                                          "HH:mm:ss",
                                        ).format("hh:mm A")
                                      : ""}
                                    -{" "}
                                    {item.EndTime
                                      ? moment(item.EndTime, "HH:mm:ss").format(
                                          "hh:mm A",
                                        )
                                      : ""}
                                    {arr?.length !== index + 1 && ","}
                                  </div>
                                ),
                              )
                            : ""
                        }
                      />
                    ),
                  }}
                  // cells={{
                  //   data: (props: any) => (
                  //     <td>
                  //       {props.dataItem.Timings.length > 0
                  //         ? props.dataItem.Timings.map(
                  //             (item: any, index: number, arr: any[]) => (
                  //               <div key={index}>
                  //                 <div className="fw-bold">
                  //                   {item.Day.length > 0
                  //                     ? item.Day.split(",").join(", ")
                  //                     : ""}
                  //                 </div>
                  //                 {item.StartTime
                  //                   ? moment(item.StartTime, "HH:mm:ss").format(
                  //                       "hh:mm A",
                  //                     )
                  //                   : ""}
                  //                 -{" "}
                  //                 {item.EndTime
                  //                   ? moment(item.EndTime, "HH:mm:ss").format(
                  //                       "hh:mm A",
                  //                     )
                  //                   : ""}
                  //                 {arr?.length === index + 1 && ","}
                  //               </div>
                  //             ),
                  //           )
                  //         : ""}
                  //     </td>
                  //   ),
                  // }}
                />
                {/* {/* <Column
                  field="StartTime"
                  title="Start Time"
                  cells={{
                    data: (props: any) => (
                      <td>
                        {props.dataItem.StartTime
                          ? moment(props.dataItem.StartTime, "HH:mm:ss").format(
                              "hh:mm A",
                            )
                          : ""}
                      </td>
                    ),
                  }}
                />
                <Column
                  field="EndTime"
                  title="EndTime"
                  cells={{
                    data: (props: any) => (
                      <td>
                        {props.dataItem.EndTime
                          ? moment(props.dataItem.EndTime, "HH:mm:ss").format(
                              "hh:mm A",
                            )
                          : ""}
                      </td>
                    ),
                  }}
                /> */}
                <Column
                  field="ID"
                  title="Actions"
                  width={110}
                  cells={{ data: ActionCell }}
                  filterable={false}
                  locked={true}
                />
              </KendoGrid>
            ) : (
              <AlertBox />
            )}
          </ShadowCard>
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default DoctorTimingForm;
